import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { useParams, Link } from "react-router-dom";

const BlogDetail = () => {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
        fetch(
            `https://codebuddys.in/wp-json/wp/v2/posts?slug=${slug}&_embed`
        )
            .then((res) => {
                if (!res.ok) throw new Error("Post Detail Error");
                return res.json();
            })
            .then((data) => {
                if (data && data.length > 0) {
                    setPost(data[0]);
                } else {
                    setPost(null);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error("Post Fetch Error:", error);
                setLoading(false);
            });
    }, [slug]);

    const getImage = (p) => {
        const featured = p?._embedded?.["wp:featuredmedia"]?.[0]?.source_url;
        if (featured) return featured;

        const content = p?.content?.rendered || "";
        const match = content.match(/<img[^>]+src="([^">]+)"/);
        return match ? match[1] : "";
    };

    return (
        <>
            <Header />
            <section className="blog-detail-section">
                {loading && <div className="blog-loading">Loading article...</div>}

                {!loading && !post && (
                    <div className="blog-loading">Article not found.</div>
                )}

                {!loading && post && (
                    <div className="blog-detail-wrapper">
                        <div className="blog-hero-header">
                            <div className="blog-hero-content">
                                <Link to="/blogs" className="back-link">
                                    ← Back to Blogs
                                </Link>
                                
                                <div className="blog-meta-top">
                                    <span className="blog-date-badge">
                                        {new Date(post.date).toLocaleDateString("en-US", {
                                            year: "numeric",
                                            month: "long",
                                            day: "numeric"
                                        })}
                                    </span>
                                </div>

                                <h1 dangerouslySetInnerHTML={{ __html: post.title?.rendered }}></h1>
                            </div>
                        </div>

                        {getImage(post) && (
                            <div className="blog-featured-image-container">
                                <div className="blog-featured-image">
                                    <img src={getImage(post)} alt={post.title?.rendered} />
                                </div>
                            </div>
                        )}

                        <div className="blog-content-container">
                            <div 
                                className="blog-main-content"
                                dangerouslySetInnerHTML={{ __html: post.content?.rendered }}
                            ></div>
                        </div>
                    </div>
                )}

            </section>
            <Footer />
        </>
    );
};

export default BlogDetail;